import { useParams } from "react-router-dom";
import { CmpTable, SectionTitle } from "../shared";
import { COUNTRY_LIST } from "../../utils";
import { GET_ALL_TIERS } from "./query";
import SubComponent from "./SubComponent";

const CountryTierList = () => {
    const { country } = useParams();

    const columns = [
        {
            header: "Tier Name",
            accessorKey: "tierName",
        },
        {
            header: "Order",
            accessorKey: "orderNo",
        },
    ];

    const renderSubComponent = (data) => {
        return <SubComponent data={data.row.original} row={data.row} />;
    };

    return (
        <>
            <SectionTitle
                title={`${COUNTRY_LIST[country.toUpperCase()]}: Tier List`}
                backUrl="/allergan-pro/tier"
            />

            <CmpTable
                QUERY={GET_ALL_TIERS}
                headers={columns}
                renderSubComponent={renderSubComponent}
                dataPath="allAllerganProTiers"
                variables={{
                    filter: {
                        country: {
                            equalTo: country.toUpperCase(),
                        },
                    },
                }}
            />
        </>
    );
};

export default CountryTierList;
